import React, { Suspense } from 'react';
import successAnimation from '../assets/lottie/success_animation.json';
var Lottie = React.lazy(function () {
    return import(
    /* webpackChunkName: "lottie-react", webpackPrefetch: true  */ 'lottie-react');
});
var SuccessAnimation = function () { return (React.createElement(Suspense, { fallback: React.createElement("div", { style: {
            width: '200px',
            height: '200px',
        } }) },
    React.createElement(Lottie, { loop: false, autoplay: true, animationData: successAnimation, height: 200, width: 200, style: { width: 200, height: 200 } }))); };
export default SuccessAnimation;
